export const getModalInfoByType = (
	changeDateType: 'start' | 'end',
	startDateValue: string | null,
	endDateValue: string | null,
) =>
	({
		start: {
			type: 'start',
			label: 'Fecha de inicio',
			initialValue: startDateValue,
		},
		end: {
			type: 'end',
			label: 'Fecha de cierre',
			initialValue: endDateValue,
		},
	}[changeDateType || 'start']);
